import type { BoxProps } from '@mui/material/Box';
import type { Theme, SxProps } from '@mui/material/styles';

import Box from '@mui/material/Box';

// ----------------------------------------------------------------------

type InvoiceTotalSummaryProps = BoxProps & {
  taxes?: number;
  shipping?: number;
  subtotal?: number;
  discount?: number;
  totalAmount?: number;
  shippingEnabled?: boolean;
};

export function InvoiceTotalSummary({
  sx,
  taxes,
  shipping,
  subtotal,
  discount,
  totalAmount,
  shippingEnabled,
  ...other
}: InvoiceTotalSummaryProps) {
  const rowStyles: SxProps<Theme> = {
    display: 'flex',
    alignItems: 'center',
  };

  const labelStyles: SxProps<Theme> = {
    color: 'text.secondary',
  };

  const valueStyles: SxProps<Theme> = {
    width: 160,
    textAlign: 'right',
  };

  // Formatteringsfunktion med dansk format og 2 decimaler
  const formatPrice = (price?: number) =>
    price !== undefined
      ? new Intl.NumberFormat('da-DK', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }).format(price) + ' kr.'
      : '-';

  return (
    <Box
      sx={[
        {
          mt: 3,
          gap: 2,
          display: 'flex',
          textAlign: 'right',
          typography: 'body2',
          alignItems: 'flex-end',
          flexDirection: 'column',
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      {...other}
    >
      {shippingEnabled && (
        <Box sx={rowStyles}>
          <Box component="span" sx={labelStyles}>
            Levering & afhentning
          </Box>
          <Box component="span" sx={valueStyles}>
            {formatPrice(shipping)}
          </Box>
        </Box>
      )}

      <Box sx={rowStyles}>
        <Box component="span" sx={labelStyles}>
          Moms
        </Box>
        <Box component="span" sx={valueStyles}>
          {formatPrice(subtotal)}
        </Box>
      </Box>

      <Box sx={[rowStyles, { typography: 'subtitle1' }]}>
        <Box component="span">Total</Box>
        <Box component="span" sx={valueStyles}>
          {formatPrice(totalAmount)}
        </Box>
      </Box>
    </Box>
  );
}
